// DTM
import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import text from "../helper/text";
import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  float: left;
  width: 100%;
  height: 584px;
  margin-bottom: 25px;
  @media (min-width: 1400px) {
    width: 1400px;
    padding: 0 calc(50% - 700px);
  }
  @media (max-width: 1100px) {
    height: auto;
  }
  @media (max-width: 700px) {
    height: 330px;
    margin: 0;
  }
`;
const Display = styled.div`
  height: 584px;
  width: calc(100% - 50px);
  margin: 0 25px;
  float: left;
  overflow: hidden;
  position: relative;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  @media (max-width: 1100px) {
    height: 0;
    padding-bottom: 46%;
  }
  @media (max-width: 700px) {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
  }
`;
const Over = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 36px;
  opacity: 0.6;
  background-color: #000000;
  display: flex;
  justify-content: center;
  @media (max-width: 1100px) {
    display: none;
    overflow: hidden;
    height: 0;
    width: 0;
  }
`;
const Title = styled.div`
  padding-top: 4px;
  padding-right: 5px;
  height: 24px;
  font-family: Lato;
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.4px;
  color: rgba(255, 255, 255, 0.85);
  text-transform: uppercase;
`;
const Sub = styled.div`
  padding-top: 6px;
  padding-left: 5px;
  height: 21px;
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1.1px;
  text-align: right;
  color: rgba(255, 255, 255, 0.85);
  text-transform: uppercase;
`;

class Header extends ArticleAbstract {
  objToArr = obj => {
    let returnable = [];
    for (let i in obj) {
      returnable.push(obj[i]);
    }
    return returnable;
  };

  txtDay = d =>
    text.getAsProp(this.props.translations, `day${((d + 6) % 7) + 1}`, -1);
  txtMonth = m =>
    text.getAsProp(
      this.props.translations,
      `month${m < 9 ? "0" : ""}${m + 1}`,
      -1
    );

  render() {
    let next = this.objToArr(this.props.calendar)
      .filter(i => i.end > new Date())
      .sort((a, b) => a.end > b.end)[0];
    let viewings = [];
    if (next && next.start) {
      viewings.push(new Date(next.start - (2 * 24 + 9) * 60 * 60 * 1000));
      viewings.push(new Date(next.start - (1 * 24 + 9) * 60 * 60 * 1000));
    }
    if (next && next.viewings && next.viewings.length > 0) {
      viewings = [];
      next.viewings.forEach(
        i => (i && i.start ? viewings.push(i.start) : null)
      );
    }
    return (
      <Wrapper>
        <Display style={this.image()}>
          <Over>
            <Title>Eerstvolgende kijkdagen</Title>
            <Sub>
              {viewings.map(
                (v, i) =>
                  `${i > 0 ? " & " : ""}${this.txtDay(
                    v.getDay()
                  )} ${v.getDate()} ${this.txtMonth(
                    v.getMonth()
                  )} ${v.getFullYear()}`
              )}, 10:00 tot 17:00 uur
            </Sub>
          </Over>
        </Display>
      </Wrapper>
    );
  }
}
const mapStateToProps = state => {
  return {
    calendar: state.calendar.data,
    translations: state.translations.data
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js